// Profile panel — photo, identity, contact links, resume download.
import React from 'react';
import { MailIcon, LinkedInIcon, GitHubIcon, DownloadIcon } from './Icons';

const CONTACTS = [
  { Icon: MailIcon, label: 'atuldpk06@gmail.com', href: 'mailto:atuldpk06@gmail.com' },
  { Icon: LinkedInIcon, label: 'linkedin.com/in/attuul-geriyan', href: 'https://www.linkedin.com/in/attuul-geriyan/' },
  { Icon: GitHubIcon, label: 'github.com/attuulGeriyan', href: 'https://github.com/attuulGeriyan' }
];

const SHORTCUTS = [
  ['⌘K', 'search'],
  ['tab', 'autocomplete'],
  ['↑ ↓', 'history'],
  ['ctrl + l', 'clear']
];

const ProfileCard3D = () => (
  <div className="profile-pane">
    <div className="profile-card">
      <div className="profile-card-head">
        <span>profile.json</span>
        <span className="profile-live">
          <span className="status-dot" />
          live
        </span>
      </div>

      <div className="profile-card-body">
        <div className="profile-image-wrapper">
          <img src="/profile.jpg" alt="Attuul Geriyan" className="profile-image" />
        </div>

        {/* Real heading elements: search engines and screen readers
            use these to identify whose page this is. */}
        <div className="profile-identity">
          <h1 className="profile-name">Attuul Geriyan</h1>
          <h2 className="profile-title">Applied AI Lead</h2>
          <div className="profile-org">Agito Global · Remote, UK</div>
        </div>

        <div className="profile-contacts">
          {CONTACTS.map(({ Icon, label, href }) => (
            <a key={label} className="profile-contact" href={href} target="_blank" rel="noreferrer">
              <span className="profile-contact-icon"><Icon /></span>
              <span>{label}</span>
            </a>
          ))}
        </div>
      </div>
    </div>

    <a
      className="resume-button"
      href="/Attuul_Geriyan_Resume.pdf"
      download
      aria-label="Download resume (PDF)"
    >
      <DownloadIcon />
      <span>Download resume</span>
      <span className="resume-button-ext">— pdf</span>
    </a>

    <div className="shortcuts">
      {SHORTCUTS.map(([key, label]) => (
        <div key={key} className="shortcut-row">
          <span className="shortcut-key">{key}</span>
          <span className="shortcut-label">{label}</span>
        </div>
      ))}
    </div>
  </div>
);

export default ProfileCard3D;
